document.addEventListener('DOMContentLoaded', function() {
    var dts = document.querySelectorAll('dl dt');

    dts.forEach(function(dt) {
        dt.addEventListener('click', function() {
            var dd = this.nextElementSibling;
            var isActive = dd.classList.contains('active');
            document.querySelectorAll('dl dd').forEach(function(el) {
                el.classList.remove('active');
            });
            if (!isActive) {
                dd.classList.add('active');
            }
        });
    });
});
